import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/stores/store";
import envSettings from "../../services/system/envSettings";
import storageSession from "redux-persist/lib/storage/session";
import { persistReducer } from "redux-persist";

const initialState = {
  showInterestCalculator: false,
  showInterestCalculation: false,
  paymentStatus: {
    isSuccess: false,
    amountPayment: 0,
  },
};

const slice = createSlice({
  name: "activeLoansSlice",
  initialState,
  reducers: {
    setShowInterestCalculator(
      state,
      {
        payload,
      }: PayloadAction<{
        showInterestCalculator: boolean;
      }>
    ) {
      state.showInterestCalculator = payload.showInterestCalculator;
    },
    setShowInterestCalculation(
      state,
      {
        payload,
      }: PayloadAction<{
        showInterestCalculation: boolean;
      }>
    ) {
      state.showInterestCalculation = payload.showInterestCalculation && envSettings.INTEREST_CALCULATION;
    },
    setPaymentStatus(
      state,
      {
        payload,
      }: PayloadAction<{
        isSuccess: boolean;
        amountPayment: number;
      }>
    ) {
      state.paymentStatus = payload;
    },
    setDefaultPaymentStatus(state) {
      state.paymentStatus = initialState.paymentStatus;
    },
  },
});

export const { setShowInterestCalculator, setShowInterestCalculation, setPaymentStatus, setDefaultPaymentStatus } =
  slice.actions;

const activeLoansPersistConfig = {
  key: "activeLoans",
  storage: storageSession,
  whitelist: ["paymentStatus"],
};

export const activeLoansReducer = persistReducer(activeLoansPersistConfig, slice.reducer);

export const selectShowInterestCalculator = (state: RootState) => state.activeLoansSlice.showInterestCalculator;

export const selectShowInterestCalculation = (state: RootState) => state.activeLoansSlice.showInterestCalculation;

export const selectPaymentStatus = (state: RootState) => state.activeLoansSlice.paymentStatus;
